<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
    class="balance-selector"
  >
    <template slot="select-header"> {{ letter.changeCoin }} </template>
    <template slot="select-content">
      <p class="coins-tip">{{ letter.attentionCoinUse }}</p>
      <p class="current-balance select-items-popup active">
        <span>{{ curBalanceItem.currency }}</span>
        <span>{{ letter.curBalance }}: {{ curBalanceItem.amount }}</span>
      </p>
      <ul class="area-select-container">
        <li
          v-show="item.currency !== curBalanceItem.currency"
          v-for="(item, index) in balanceList"
          class="balance-list select-items-popup"
          :dataCode="item.currency"
          :pointValue="item.currency"
          :key="index"
          @click="selectBalanceItem(item)"
        >
          <span>{{ item.currency }}</span>
          <span>{{ letter.curBalance }}: {{ item.amount }}</span>
        </li>
      </ul>
    </template>
  </SelectContianer>
</template>
<script>
import selectContainer from '@mixins/officialWebStore/selectContainer';
import { mapState, mapGetters } from 'vuex';

export const HIDE_COINS_SELECTOR = 'hideCoinsSelector';
export default {
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId
    }),
    ...mapGetters(['gameInfoConfig']),
    coinsName() {
      return this.gameInfoConfig?.coinConfig?.coinsName || '';
    }
  },
  props: ['curBalanceItem', 'balanceList'],
  methods: {
    selectBalanceItem(balanceItem) {
      this.$emit(HIDE_COINS_SELECTOR, balanceItem);
    }
  },
  mixins: [selectContainer]
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';
.balance-selector {
  z-index: 1002;
}
.balance-list,
.current-balance {
  display: flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  padding: 37px 0;
  width: 100%;
  font-size: 26px;
  color: #333;
  border-top: 2px solid #dcdcdc;
  cursor: pointer;
}

.current-balance.active {
  color: $btnBg;
}
.coins-tip {
  margin-bottom: 24px;
  font-size: 24px;
  line-height: 28px;
  text-align: left;
  color: $btnBg;
}
::v-deep .select-header {
  font-weight: bold;
}
</style>
